export default {
  contact_provider: 'Aby to włączyć, skontaktuj się ze swoim dostawcą.',
};
